var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchRandomLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.0953 5.36719H16.3717C16.1073 5.36719 15.8562 5.48269 15.6843 5.68378L6.15614 16.8244H0.90454C0.404903 16.8244 0 17.2293 0 17.7289C0 18.2285 0.404903 18.6334 0.90454 18.6334H6.57286C6.83728 18.6334 7.08843 18.5176 7.26028 18.3168L16.7884 7.17622H23.0953C23.5949 7.17622 23.9999 6.77131 23.9999 6.27168C23.9999 5.77204 23.5949 5.36719 23.0953 5.36719Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7507 5.64822L20.8864 2.63315C20.542 2.27076 19.9692 2.25628 19.6077 2.60057C19.2456 2.94459 19.2308 3.51716 19.5751 3.87926L21.8476 6.27141L19.5751 8.66356C19.2308 9.02567 19.2456 9.59824 19.6077 9.94225C19.7829 10.1087 20.0069 10.191 20.2306 10.191C20.4697 10.191 20.7085 10.0967 20.8864 9.90939L23.7507 6.89433C24.0827 6.54521 24.0827 5.99738 23.7507 5.64822Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.096 16.8229H16.7946L13.6288 13.0463C13.3086 12.6637 12.7378 12.6127 12.3546 12.9341C11.972 13.2552 11.9216 13.8253 12.2425 14.2083L15.6796 18.3087C15.8515 18.5137 16.1051 18.6322 16.3728 18.6322H23.0964C23.596 18.6322 24.0006 18.227 24.0006 17.7274C24.0006 17.2278 23.5956 16.8229 23.096 16.8229Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6757 9.79416L7.26871 5.69372C7.09654 5.4869 6.84178 5.36719 6.57286 5.36719H0.90454C0.404903 5.36719 0 5.77209 0 6.27168C0 6.77127 0.404903 7.17622 0.90454 7.17622H6.14831L9.28428 10.9501C9.46338 11.1654 9.72087 11.2767 9.98046 11.2767C10.184 11.2767 10.389 11.2082 10.5579 11.068C10.9422 10.7488 10.995 10.1783 10.6757 9.79416Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7506 17.1053L20.8864 14.0903C20.542 13.7276 19.9692 13.7134 19.6077 14.0577C19.2456 14.4015 19.2308 14.9743 19.5751 15.3364L21.8475 17.7286L19.5751 20.1207C19.2308 20.4828 19.2456 21.0554 19.6077 21.3994C19.7828 21.5658 20.0069 21.6482 20.2306 21.6482C20.4697 21.6482 20.7085 21.5541 20.8864 21.3665L23.7507 18.3515C24.0826 18.0023 24.0826 17.4545 23.7506 17.1053Z",
    fill: "#000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.0001,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchRandomLarge);
export default __webpack_public_path__ + "static/media/search-random-large.6751fbee9b0d071c15aef1738a366e0e.svg";
export { ForwardRef as ReactComponent };